'use strict';

import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader';
import {
    createMaterialAndSetBaseColor,
    lazyLoadingData, rgbaToHexA,
} from '../../functions';
import * as THREE from 'three';
import {Group} from 'three';
import {sortFloors} from './autoBuildingFunctions';
import {fitModelAndSetMaxMinProperties} from '../controls/zoomControl';
import { settingsData, threeJsVariables, isMobile, Buildings } from '../../settings';
import {icon360} from '../icon360/icon360';
import {getCurrentCameraDistance, getOrbitControlsDistanceAndAngle, rotateToCamera} from '../controls/orbitControls';
import {BuildingLabels} from "../building-switch/buildingLabels";
import {createTooltip} from "../flatTooltip/flatTooltip";
import {SelectedObjectType, ViewMode} from "../../common";
import {FBXLoader} from 'three/examples/jsm/loaders/FBXLoader';
import {Vector3} from 'three';
import {Euler} from 'three';
import { calculateBoxForSelectionBoxes } from '../building-switch/buildingHover';
import { getCurrentLang } from '../language/langSwitcher';

let _hightlights = null

export function loadHighlightsModelFromAzure(response, dracoLoader) {
    const [buildingInfo] = response;
    const {cdnRepository, projectFolder} = config;
    const {format} = config.resources.buildings;
    const {folder} = config.resources.selectionBoxes;
    let loader;

    const modelsPromiseArray = [];

    switch (format) {
        case 'gltf':
            loader = new GLTFLoader();
            loader.setDRACOLoader(dracoLoader);
            break;
        case 'fbx':
            loader = new FBXLoader();
            break;

    }

    buildingInfo.data.buildings.forEach((building, index) => {
        // if (index > domains.length -1){
        //   index = 0;
        // }

        // const url = `${domains[index]}/${building.buildingEngineId}_selectBoxes.${buildingModelsFormat}`;
        const url = `${cdnRepository}/${projectFolder}/${folder}/${building.buildingEngineId}_selectBoxes.${format}`;
        const model = lazyLoadingData(loader, url);

        modelsPromiseArray.push(model);
    });

    return modelsPromiseArray;
}


export function bundle_initAutoHighlightsScript(response) {
    const crmData = response.filter(el => Array.isArray(el))[0];
    const [crmSettings, crmProps, dictionary] = crmData;
    const highlightsData = response.filter(el => !Array.isArray(el));

    settingsData.allCrmData = crmProps.data;

    concatPropsAndHighlights(crmProps, highlightsData, crmSettings);
    addHighlightsToScene(highlightsData);
    setProjectSettings(crmSettings, dictionary);

    BuildingLabels(highlightsData);

    if (!isMobile) {
        createTooltip();
    }
}


export function initAutoHighlightsScript(response) {
    const crmData = response.filter(el => Array.isArray(el))[0];
    const [crmSettings, crmProps, dictionary] = crmData;
    const highlightsData = response.filter(el => !Array.isArray(el));

    settingsData.allCrmData = crmProps.data;

    const highlights = getHighlightsFromResponse(highlightsData);
    concatPropsAndHighlights(crmProps, highlights, crmSettings);
    addHighlightsToScene(highlights);
    setProjectSettings(crmSettings, dictionary);

    BuildingLabels(highlights);

    if (!isMobile) {
        createTooltip();
    }
}

function addHighlightsToScene(highlights) {
    const {projectRotation} = config.threejs;
    const projectHighlightsGroup = new Group();
    projectHighlightsGroup.rotation.set(projectRotation.x, projectRotation.y, projectRotation.z);
    projectHighlightsGroup.name = 'Project Selection Boxes';
    projectHighlightsGroup.add(...highlights);
    calculateBoxForSelectionBoxes(highlights);

    fitModelAndSetMaxMinProperties();

    _hightlights = projectHighlightsGroup
    //threeJsVariables.scene.add(projectHighlightsGroup);
}

export const getHighlights = () => _hightlights;

export const getSelectionsByName = (name) => _hightlights.getObjectByName(name + '_selectionBoxes');

function getHighlightsFromResponse(highlights) {
    const {format} = config.resources.buildings;
    const highlightsArr = [];

    switch (format) {
        case 'gltf':
            highlights.forEach(el => {
                const sBoxBuilding = el.scene.children[0];
                highlightsArr.push(sBoxBuilding);
            });
            break;
        case 'fbx':
            highlights.forEach(el => highlightsArr.push(el));
            break;

    }

    return highlightsArr;
}

function concatPropsAndHighlights(props, highlights, settings) {
    const dataProps = props.data;

    highlights.forEach(building => {
        const buildingName = building.name.split('_')[0];
        const buildingClass = Buildings.getBuilding(buildingName);
        const info = createBuildingInfo(building, dataProps, settings);
        //building.children = sortFloors(building);
        building.children = building.children.sort((prev, next) => {
            let n1 = parseInt(prev.name.split('_')[1]);
            let n2 = parseInt(next.name.split('_')[1]);
            return n1 - n2
        });

        building.children.forEach((floor, index) => {

            floor.children = floor.children.sort((prev, next) => {
                if (prev.name.startsWith(config.resources.selectionBoxes.floorPlugName)) {
                    return 1
                } else {
                    let n1 = parseInt(prev.name.split('_')[2]);
                    let n2 = parseInt(next.name.split('_')[2]);
                    return n1 - n2
                }
            });

            const floorNumber = Number(floor.name.split('_')[1]);
            floor.userData.base_scale = new THREE.Vector3(floor.scale.x, floor.scale.y, floor.scale.z);
            floor.userData.basePosition = new THREE.Vector3(floor.position.x, floor.position.y, floor.position.z);
            if (floor.children.length) {
                const floorArr = [];
                floor.children.forEach((apt, index) => {
                    if (!apt.name.startsWith(config.resources.selectionBoxes.floorPlugName)) {
                        const existProp = dataProps.find(prop => prop.engineId === apt.name);
                        if (existProp) {
                            setDataToApartment(apt, existProp, index);
                            createMaterialAndSetBaseColor(apt);
                            // info && info.all_apartments.push(apt);
                            info && buildingClass.apartments.push(apt);
                        } else {
                            setHardcodeDataToApartment(apt, floorNumber);
                            createMaterialAndSetBaseColor(apt);
                        }
                        add360Icon(apt, existProp);
                    } else {
                        setAttributeToPlug(apt, floorNumber);
                        setDataToPlug(apt, floorNumber);
                        if (info){
                            // info.flooring_obj[floorNumber] = apt;
                            buildingClass.floorsPlug.push({floor:floorNumber, data: apt});
                        }
                        // info && info.flooring_obj.push(apt);
                    }

                    if (apt.name.match(/_amenity_/g)) {
                      createMaterialAndSetBaseColor(apt);
                      setDataToAmenities(apt, index);
                      // info && info.customSelections.push(apt);
                        buildingClass.customSelections.push(apt);
                    }

                    floorArr.push(apt);
                });

                // Reverse array if first element is CAP
                if (floorArr[0].name.startsWith(config.resources.selectionBoxes.floorPlugName)) {
                    const reverse = floorArr.reverse();
                    // info && info.floor_obj.push(reverse);
                    if (info){
                        // info.floor_obj[floorNumber] = floorArr;
                        buildingClass.addSelection({floor: floorNumber, data: floorArr});
                    }
                } else {
                    // info && info.floor_obj.push(floorArr);
                    if (info){
                        // info.floor_obj[floorNumber] = floorArr;
                        buildingClass.addSelection({floor: floorNumber, data: floorArr});
                    }
                }

            } else {

                // floor amenities
                createMaterialAndSetBaseColor(floor);
                setDataToAmenities(floor, index);

              if (floor.name.match(/_amenity_/g)) {
                    // info && info.customSelections.push(floor);
                  buildingClass.customSelections.push(floor);
                }
            }
        });

        buildingClass.addInfo(info);

        buildingClass.selectionsGroup = building;
        // info && buildings_info.push(info);
    });
}

function setHardcodeDataToApartment(apt, count) {
    apt.userData.floor = count - 1;
    // apt.userData.crm_data={};
    // apt.userData.crm_data.status = 'Available';
    // apt.userData.crm_data.floorNum = count;
    apt.userData.base_position = {
        x: apt.position.x,
        y: apt.position.y,
        z: apt.position.z,
    };

}

export function createBuildingInfo(building, data, settings) {
    const getBuildingInfo = settings.data.buildings.filter(buildingInfo => building.name.startsWith(buildingInfo.buildingEngineId))[0];

    let towerName = [];

    if (Array.isArray(getBuildingInfo.buildingTitle) && getBuildingInfo.buildingTitle.length){

        getBuildingInfo.buildingTitle.forEach(title => {
           if (!title.value.length){
               title.value = getBuildingInfo.buildingName;
           }
        });

        towerName = getBuildingInfo.buildingTitle;
    } else {
        towerName = getBuildingInfo.buildingName;
    }

    if (getBuildingInfo) {
        const info = {
            // towerName: getBuildingInfo.buildingName,
            towerName: towerName,
            labelName: getBuildingInfo.buildingLabel,
            buildingIcon: getBuildingInfo.buildingIcon,
            // isActive: false,
            // mouseHover: false,
            // name: getBuildingInfo.buildingEngineId,
            // objects_to_opacity: [],
            // objects_to_appear: [],
            // all_apartments: [],
            // floor_obj: {},
            // flooring_obj: {},
            searchResult: [],
            // customSelections: [],
            crm_data: data.filter(prop => prop.engineId.startsWith(getBuildingInfo.buildingEngineId)),
            availableApartments: data.filter(prop => prop.engineId.startsWith(getBuildingInfo.buildingEngineId)).filter(apt => apt.status === 'Available').length
        };

        return info;
    }

}

function setAttributeToPlug(plug, floor) {
    plug.material.transparent = true;
    plug.material.opacity = 0;
    plug.visible = false;
}

export function setDataToApartment(apartment, data) {
    if (data.facing){
        const  facing = data.facing.split(/,|-/);
        data.facing = [...new Set(facing)];
    } else {
        data.facing = [];
    }

    apartment.userData.crm_data = data;

    const worldPosition = apartment.getWorldPosition(new THREE.Vector3());
    apartment.userData.baseWorldPosition = worldPosition;
    apartment.userData.base_position = {
        x: apartment.position.x,
        y: apartment.position.y,
        z: apartment.position.z,
    };
    // apartment.userData.floor = data.floorNum - config.resources.selectionBoxes.floorNumberCorrection;
    apartment.userData.floor = data.floorNum;
    apartment.userData.type = SelectedObjectType.SelectionBoxes;
    apartment.userData.isActive = false;
    apartment.userData.isClicked = false;
}

function setDataToPlug(plug, floorNumber) {
    const worldPosition = plug.getWorldPosition(new THREE.Vector3());
    plug.userData.baseWorldPosition = worldPosition;
    plug.userData.base_position = {
        x: plug.position.x,
        y: plug.position.y,
        z: plug.position.z,
    };
    plug.userData.floor = floorNumber;
}

const dataOfAmenities = (floor) => {
    if (!config.features.amenities || config.features.amenities.length <= 0) return;

    if (floor.name.match(/_amenity_/g)) {
        const amenity = config.features.amenities.find(amen => amen.engineId === floor.name);
        floor.userData.floor = amenity.floor;
        floor.userData.crm_data = config.features.amenities.find(amen => amen.engineId === floor.name);
    }
}

export function setDataToAmenities(amenities, index) {
    amenities.userData.type = SelectedObjectType.SelectionBoxes;
    amenities.userData.customSelection = true;
    dataOfAmenities(amenities, index);
}

export function setProjectSettings(settingsFromCrm, dictionary) {
    if (settingsFromCrm && settingsFromCrm.data) {
        const settings = settingsFromCrm.data;
        config['crmProjectSettings'] = settings;
        // config['dictionary'] = dictionary.data;
        for (const key in settings) {
            config[key] = settings[key];
        }
        // startProject(settings);
    }
}

function add360Icon(apt, existProp) {
    return;
    if (apt.userData.coord && existProp.assets?.tours360) {

        const coord = apt.userData.coord.split(',');
        const x = Number(coord[0]);
        const y = Number(coord[1]);
        const z = Number(coord[2]);

        const icon = icon360.get360Icon({x: x, y: 0, z: z}, {x: 0, y: 0, z: 0}, {x: 0.3, y: 0.3, z: 0.3}, 'icon360');
        icon.visible = false;
        apt.add(icon);
    }
}

// export function manualHide360Icons() {
    // return;
    // const activeBuilding = buildings_info.find(building => building.isActive);
    // if (!activeBuilding) {
    //     return;
    // }
    // const buildingOnScene = threeJsVariables.scene.getObjectByName(`${activeBuilding.name}_${SelectedObjectType.SelectionBoxes}`);
    // buildingOnScene.traverse(el => {
    //     if (el.name === 'icon360') {
    //         el.visible = false;
    //     }
    // });
// }

// export function toggle360Icons() {
//     return;
//     if (settingsData.activeViewMode !== ViewMode.Orbit) {
//         if (!threeJsVariables.orbitControls.enabled) {
//             return;
//         }
//         const activeBuilding = buildings_info.find(building => building.isActive);
//         if (!activeBuilding) {
//             return;
//         }
//         const buildingOnScene = threeJsVariables.scene.getObjectByName(`${activeBuilding.name}_${SelectedObjectType.SelectionBoxes}`);
//
//         const currentCameraDistance = getCurrentCameraDistance();
//         const {cylinder} = settingsData.globalSettings.orbitControlsDistanceAndPan;
//         const {currentMinDistance} = getOrbitControlsDistanceAndAngle();
//
//         if (Math.ceil(currentMinDistance) !== Math.ceil(cylinder.min)) {
//             return;
//         }
//
//         if (currentCameraDistance <= currentMinDistance + 10) {
//
//             switch (settingsData.activeViewMode) {
//                 case ViewMode.Cylinder:
//                     buildingOnScene.traverse(el => {
//                         if (el.name === 'icon360') {
//                             el.visible = true;
//                             el.rotation.y = rotateToCamera(-Math.PI / 2);
//                         }
//                     });
//                     break;
//                 case ViewMode.FloorPlan:
//                     buildingOnScene.traverse(el => {
//                         if (el.name === 'icon360') {
//                             el.visible = false;
//                             el.rotation.y = rotateToCamera(-Math.PI / 2);
//                         }
//                     });
//                     break;
//
//             }
//         } else {
//             buildingOnScene.traverse(el => {
//                 if (el.name === 'icon360') {
//                     el.visible = false;
//                     el.rotation.y = rotateToCamera(-Math.PI / 2);
//                 }
//             });
//         }
//     }
// }
